import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getProject, getEntries, uploadImage, updateData } from '../functions/firebaseFunctions';
import Tag from '../components/tag';
import Goals from '../components/Goals';
import Entry from '../components/Entry';
import Field from '../components/Field';
import Bullets from '../components/Bullets';
import { Add } from '../components/Icons';

import { auth } from "../functions/firebaseFunctions";
import { onAuthStateChanged } from "firebase/auth";
import GitHubLink from '../components/GitHubLink';

const shortDesc = (project) => {
    const shortDesc = `Check out this ${project.title} project that Saveliy ${project.completion === 100 ? 'made' : 'is working on'}.`
    return shortDesc
}

const buttonStyle = {
    backgroundColor: 'var(--mdGray)',
    margin: 5,
    borderWidth: 0,
}

const imageStyle = {
    width: 200,
    height: 200,
    borderRadius: 15,
    objectFit: 'cover',
    justifySelf: 'center',
    marginBottom: 5
}

export default function Project() {
    const { projectId } = useParams();
    const [project, setPoject] = useState(undefined);
    const [entries, setEntries] = useState(undefined);
    const [tags, setTags] = useState(undefined);
    const [image, setImage] = useState(undefined)
    const [uploading, setUploading] = useState(false);
    useEffect(() => {
        //console.log('change in ProjectId')
        getProject(projectId).then(projectRes => {
            setPoject(projectRes);
            //console.log('project:', projectRes)
            setImage(projectRes.img || null)
            setTags(projectRes.tags || []) // if there are tags in this project set them to a separate state
            getEntries(projectId, null).then(entriesRes => {
                setEntries(entriesRes);
            }).catch(error => { console.log(error) });
        }).catch(error => { console.log(error) });
    }, [projectId]);

    const addEntry = (newEntry) => {
        const updatedEntries = [...entries] // copy the array
        updatedEntries.unshift(newEntry) // add the new entry at the start of the array
        setEntries(updatedEntries) // update the state
    }

    const updateEntry = (index, updatedEntry) => {
        const updatedEntries = [...entries] // copy the array
        updatedEntries[index] = updatedEntry // add the new entry at the start of the array
        setEntries(updatedEntries) // update the state
    }

    const deleteEntry = (index) => {
        const updatedEntries = [...entries] // copy the array
        updatedEntries.splice(index, 1) // add the new entry at the start of the array
        setEntries(updatedEntries) // update the state
    }

    const handleProjectImageUpload = async (event) => {
        setUploading(true);//show uploading status
        const newImages = Array.from(event.target.files);//extract the array of images
        //console.log('newImages:', newImages)
        Promise.all(newImages.map(async (image) => { // wait for everything to finish
            const imageURL = await uploadImage(project.projectId, image);//upload the image 
            return imageURL //save the url
        })).then((imageArray) => {
            //console.log('updated array:', imageArray)
            updateData(`projects/${project.projectId}/img`, imageArray[0]).then(uploadRes => {
                if (uploadRes.success) {
                    setImage(imageArray[0])//update the local image
                    setUploading(false);//stop showing uploading status
                } else {
                    console.error('Error during record', uploadRes.message)
                }
            })
        })
    };

    const [user, setUser] = useState(undefined);// if user is undefined then it has not been fethced

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user)
            } else {
                setUser(null); // if user is null it has been fetched and the user is not logged in
            }
        });
    }, []);

    return (
        <React.Fragment>
            <section className='topSection' style={{ height: 'fit-content' }}>
                <Helmet>
                    <title>{project?.title ?? 'Project'}</title>
                    <meta name="description" content={project ? shortDesc(project) : 'Project description'} />
                    <meta property="og:description" content={project ? shortDesc(project) : 'Project description'} />
                    <meta property="og:title" content={project?.title ?? 'Project'} />
                </Helmet>
                <div style={{ maxWidth: 1000, display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 10 }} >
                    <div style={{ display: 'grid' }}>{/* Main info */}
                        {user ?
                            <Field type="h1" value={project?.title} color="black" fieldPath={`projects/${project?.projectId}/title`} />
                            :
                            <h1>{project?.title}</h1>
                        }
                        {project &&
                            image
                            ?
                            <img alt={project.title} src={image} style={imageStyle} />
                            :
                            // eslint-disable-next-line jsx-a11y/img-redundant-alt
                            <img alt='No Image - Saveliy Saunin' src='/Noimage.png' style={imageStyle} />
                        }
                        {user && <form style={{ width: 'fit-content', justifySelf: 'center' }}>
                            <label htmlFor="image-upload"
                                className='popUp btn' style={{
                                    ...buttonStyle,
                                    display: 'flex',
                                    fontSize: 16,
                                    transition: "500ms ease",
                                    cursor: 'pointer',
                                    width: 'auto'
                                }}>
                                {!uploading && <Add color='var(--orng)' size={16} />}
                                {uploading ? "Uploading ..." : "Change Image"}
                            </label>
                            <input
                                name="ProjectImage"
                                disabled={uploading}
                                style={{ display: 'none' }}
                                type="file"
                                id="image-upload"
                                accept="image/*"
                                onChange={handleProjectImageUpload}
                            />
                        </form>}
                        <ul style={{ paddingInlineStart: 0, display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                            {tags && tags.map(tag => <Tag user={user} key={tag} tag={tag} selectedTags={tags} setSelectedTags={setTags} projectId={projectId} />)}
                            {user && <Tag key="add" tag="add" selectedTags={tags} setSelectedTags={setTags} projectId={projectId} />}
                        </ul>
                        {(user || project?.github) && <GitHubLink user={user} link={project?.github} projectId={project?.projectId} />}
                        {user ?
                            <Field type="p" value={project && (project?.desc || "Enter Description")} color="black" fieldPath={`projects/${project?.projectId}/desc`} />
                            : <p>{project?.desc}</p>
                        }
                    </div>
                    {user && <Bullets project={project} />}
                    {((user === null && project?.goals)
                        //if user status is fetched and user is NOT logged in and if the project has goals
                        || // or
                        (user && project))
                        //if user status is fetched and user is logged in and the project has been fetched
                        && <Goals user={user} project={project} />
                        //then the goals will be rendered
                    }
                </div>
            </section>
            <section style={{
                placeSelf: 'top',
                justifyContent: 'center',
                display: "grid",
                padding: '0 10px 10px',
                maxHeight: 'calc( 100vh - 70px )'
            }}>
                <h2 style={{ textAlign: 'center', color: 'var(--orng)' }}>Entries</h2>
                <div style={{
                    maxWidth: 1000,
                    maxHeight: 'calc( 100vh - 105px )',
                    overflowY: 'scroll',
                }}>
                    {user && <Entry entry='new' project={project} addEntry={addEntry} />}
                    {entries ? entries.map((entry, index) =>
                        <Entry
                            key={entry.id}
                            project={project}
                            entry={entry}
                            user={user}
                            updateEntry={updateEntry}
                            deleteEntry={deleteEntry}
                            index={index}
                        />)
                        :
                        <p style={{ textAlign: 'center', color: 'var(--orng)' }}>No entries yet</p>}
                </div>
            </section>
        </React.Fragment>
    )
}